import { AI_ASSISTANT_UNREAD_BADGE_CAP } from '../../AiAssistant.constants';

import {
  DEFAULT_SUBLABEL,
  UNREAD_LABEL_PLURAL_TEMPLATE,
  UNREAD_LABEL_SINGULAR,
} from './AiAssistantLauncher.constants';

export const getBadgeContent = unreadCount => {
  if (unreadCount > AI_ASSISTANT_UNREAD_BADGE_CAP) {
    return `${AI_ASSISTANT_UNREAD_BADGE_CAP}+`;
  }

  return String(unreadCount);
};

export const getSublabel = unreadCount => {
  if (unreadCount <= 0) {
    return DEFAULT_SUBLABEL;
  }

  if (unreadCount === 1) {
    return UNREAD_LABEL_SINGULAR;
  }

  return UNREAD_LABEL_PLURAL_TEMPLATE.replace('{count}', String(unreadCount));
};
